var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LabeledSelect',{attrs:{"label":_vm.t('gatekeeperConstraint.tab.namespaces.sub.scope.title'),"hover-tooltip":true,"tooltip":"Determines if cluster-scoped and/or namespaced-scoped resources are selected.","value":_vm.value,"mode":_vm.mode,"options":_vm.SCOPE_OPTIONS},on:{"input":e=>_vm.$emit('input', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }